import axios from 'axios'


const fileapi = axios.create({
  baseURL: "https://recruit.www.he-service.co.jp/",
  timeout: 5000,
  headers: {
    'Content-Type': 'multipart/form-data',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

export default fileapi
